import React from "react";
import { CustomList } from "components/index";
import { RenderProfile } from "components/render-profile";

import { useParams } from "react-router-dom";

export default function PendingSelfReviews() {
  const { quadId } = useParams();

  const columns = [
    {
      id: "reviewee",
      header: "Employee",
      accessorKey: "reviewee",
      cell: ({ getValue }) => {
        return <RenderProfile user={getValue()} />;
      },
    },
  ];

  const effectiveFilters = {
    quadrimesterId: quadId,
  };

  const exportFields = [
    "reviewee.first_name",
    "reviewee.last_name",
  ];

  return (
    <div className="flex-1 h-full">
      <CustomList
        title={"Pending Self Reviews"}
        endPoint="performance-review/pending-self-reviews"
        export={true}
        fields={exportFields}
        filters={effectiveFilters}
        columns={columns}
        showSearch={false}
        storageKey={`pending-self-reviews-${quadId}`}
        teleportFilters={true}
      />
    </div>
  );
}
